import * as api from '../../api/encargado-recupero-client';
import { 
    GET_CONFIG_FORM,
    GET_CRITERIOS_FECHA,
    GET_INSTANCIA_JUDICIAL,
    GET_ESTADOS_CASO,
    GET_TAREAS,
    GET_TIPO_GESTION,
    GET_TAREAS_USUARIO,
    GET_CASOS_BANDEJA,
    GET_RANGO_FECHAS,
    GET_XLS_CASOS_BANDEJA,
    CLEAR_CASOS_BANDEJA,
    GET_FILTROS,
    GET_COMBO_COMPETENCIA,
    GET_COMBO_REGION_CORTE,
    GET_COMBO_JUZGADO_TRIBUNAL

} from '../types';


export const configuracionFormAction = (query) => ({
    type: GET_CONFIG_FORM,
    payload: api.getConfiguracionForm(query)
});

export const obtenerTareasAction = (query) => ({
    type: GET_TAREAS,
    payload: api.getTareas(query)
});

export const obtenerEstadosCasoAction = (query) => ({
    type: GET_ESTADOS_CASO,
    payload: api.getConceptos(query)
});

export const obtenerTipoGestionAction = (query) => ({
    type: GET_TIPO_GESTION,
    payload: api.getConceptos(query)
});

export const obtenerInstanciaJudicial = (query) => ({
    type: GET_INSTANCIA_JUDICIAL,
    payload: api.getIntanciaJudicial(query)
});

export const obtenerCriteriosFechaAction = (query) => ({
    type: GET_CRITERIOS_FECHA,
    payload: api.getConceptos(query)
});

export const obtenerTareasUsuarioAction = (query) => ({
    type: GET_TAREAS_USUARIO,
    payload: api.getTareasUsuario(query)
});

export const obtenerCasosBandeja = (query) => ({
    type: GET_CASOS_BANDEJA,
    payload: api.getCasosBandeja(query)
});

export const obtenerRangoFechas = (query) => ({
    type: GET_RANGO_FECHAS,
    payload: api.getRangoFechas(query)
});

export const obtenerXlsCasosBandeja = (query) => ({
    type: GET_XLS_CASOS_BANDEJA,
    payload: api.getXlsCasosBandeja(query)
});

export const limpiarCasosBandeja = () => ({
    type: CLEAR_CASOS_BANDEJA,
    payload: { casos: [], query: null }
});
export const obtenerFiltros = (filtros) => ({
    type: GET_FILTROS,
    payload: filtros
});
export const obtenerComboCompetencia = (query) => ({
    type: GET_COMBO_COMPETENCIA,
    payload: api.getConceptos(query)
});
export const obtenerComboRegionCorte = (query) => ({
    type: GET_COMBO_REGION_CORTE,
    payload: api.getConceptos(query)
});
export const obtenerComboJuzgadoTribunal = (query) => ({
    type: GET_COMBO_JUZGADO_TRIBUNAL,
    payload: api.getComboTribunales(query)
});